import { TranslateLoader } from "@ngx-translate/core";
import { of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import * as en from "./assets/i18n/en.json";

const i18n = {
  en: en,
};

export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string) {
    return of(i18n[lang].default);
  }
}

/** not recommended due to cache issues / decoupling from build */
export function HttpLoaderFactory(http: HttpClient) {
  if (module.hot) {
    return new WebpackTranslateLoader();
  }

  return new TranslateHttpLoader(http);
}
